if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects")
      ).filter((selector) => {
        return selector != this;
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.updatePickupAvailability();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        if (typeof renderProductTimer === "function") {
          renderProductTimer();
        }
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
      document.querySelector('#AddToCartSticky').setAttribute('data-presentVarId', this.currentVariant.id);
      let inputCheckedField = this.querySelector('fieldset input:checked')
      if(inputCheckedField){
        let integerInventoryCount = parseInt(inputCheckedField.getAttribute('variant-quantity'))
        if(integerInventoryCount <= 20 && integerInventoryCount > 0){
          document.querySelector('.variant-availability_text').style.display = 'block';
        }else{
          document.querySelector('.variant-availability_text').style.display = 'none';
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);

          // if(fieldset.querySelector('input:checked').value){
          //    this.options.push(fieldset.querySelector('input:checked').value);
          // }
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value="${option}"]`
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const productSlider = document.getElementById(
        `MediaGallery-${this.dataset.section}`
      );
      if (!productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = productSlider.querySelector(
        `[data-media-id="${mediaId}"]`
      );

      productSlider.querySelectorAll("[data-media-id]").forEach((element) => {
        element.classList.remove("is-active");
      });
      activeMedia.classList.add("is-active");

      if (this.featured) return;

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = [
        document.getElementById(`product-form-${this.dataset.section}`),
      ];

      if (this.dataset.updateUrl !== "false") {
        productForms.push(document.getElementById("product-form-installment"));
      }

      productForms.filter(Boolean).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      const scope =
        this.closest("#Product-Drawer, .thb-product-detail, section") || this;

      const updateRazorpayButton = () => {
        const magicButton = scope.querySelector(".magic-buy-btn__parent");
        if (magicButton) {
          if (this.currentVariant && this.currentVariant.available) {
            magicButton.style.display = "flex";
          } else {
            magicButton.style.display = "none";
          }
        }
      };

      updateRazorpayButton();

      if (!scope.querySelector(".magic-buy-btn__parent")) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "childList") {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  (node.classList.contains("magic-buy-btn__parent") ||
                    node.querySelector(".magic-buy-btn__parent"))
                ) {
                  updateRazorpayButton();
                  observer.disconnect();
                }
              });
            }
          });
        });

        observer.observe(scope, {
          childList: true,
          subtree: true,
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
          
        });
    }

    getScopedSubmitButtons() {
      const sectionId = this.dataset.section;
      const buttons = new Set();

      const productForm = document.getElementById(`product-form-${sectionId}`);
      if (productForm) {
        productForm
          .querySelectorAll(".single-add-to-cart-button")
          .forEach((btn) => buttons.add(btn));
      }

      // Sticky ATC sits outside the form but targets it via the form attribute.
      document
        .querySelectorAll(
          `.single-add-to-cart-button[form="product-form-${sectionId}"]`
        )
        .forEach((btn) => buttons.add(btn));

      return Array.from(buttons);
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const submitButtons = this.getScopedSubmitButtons();

      if (!submitButtons.length) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (submitButton.nextElementSibling)
            //submitButton.nextElementSibling.style.display = "none";
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
          let parentContainer = submitButton.closest(
            ".product-information--inner"
          );
          if (parentContainer) {
            if (
              parentContainer.querySelector(
                "variant-selects .variations .product-form__input--color input:checked"
              )
            ) {
              let dataAttri = parentContainer
                .querySelector(
                  "variant-selects .variations .product-form__input--color input:checked"
                )
                .getAttribute("data-preorder");
              if (dataAttri == "true") {
                console.log(
                  parentContainer.querySelector(
                    "variant-selects .variations .product-form__input--color input"
                  )
                );
                submitButtonText.textContent = "Pre-Order";
                console.log(submitButton.nextElementSibling);
                submitButton.nextElementSibling.style.display = "none";

                if(document.querySelector(".shipping_text")){
                   document.querySelector(".shipping_text").style.display = "flex";
                }
                
              } else {
                submitButton.nextElementSibling.style.display = "block";

                 if(document.querySelector(".shipping_text")){
                    document.querySelector(".shipping_text").style.display = "none";
                 }
                
              }
            }
          } else {
            
            if (
              submitButton
                .closest(".quickViewContainer")
                ?.querySelector(
                  ".variant-selects .variations .product-form__input--color input:checked"
                )
            ) {
              let dataAttri = submitButton
                .closest(".quickViewContainer")
                .querySelector(
                  ".variant-selects .variations .product-form__input--color input:checked"
                )
                .getAttribute("data-preorder");
              if (dataAttri == "true") {
                submitButtonText.textContent = "Pre-Order";
                submitButton.nextElementSibling.style.display = "none";

                if(document.querySelector(".shipping_text")){
                   document.querySelector(".shipping_text").style.display = "flex"; 
                }
                
              } else {
                submitButtonText.textContent =
                  window.theme.variantStrings.addToCart;
                submitButton.nextElementSibling.style.display = "block";

                if(document.querySelector(".shipping_text")){
                   document.querySelector(".shipping_text").style.display = "none";
                }
                
              }
            }
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = this.getScopedSubmitButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      
      const variant_data = this.getVariantData();

      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          }
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = false;
                }
              });
            } 
            // else if (fieldset.querySelectorAll("input").length) {
            //   fieldset.querySelectorAll("input").forEach((input, input_i) => {
            //     input.classList.toggle(
            //       "is-disabled",
            //       fieldset_options[input_i].isUnavailable
            //     );
            //   });
            // }
          }
        });
      }
      // else {
      //  this.querySelectorAll('.product-form__input.product-form__input--block input').forEach((each)=>{
      //   if(!each.classList.contains('is-disabled')){
      //     each.classList.add('is-disabled')
      //   }
      //  })
      // }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}
if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const _this = this;
      const product_container = this.closest(".thb-product-detail");

      this.pagination = this.parentElement.querySelector(
        ".product-images-buttons"
      );
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      this.addEventListener("change", this.setupProductGallery);
      this.setupProductGallery();

      // Start Pagination

      if (this.pagination) {
        this.setupPagination();
        this.addEventListener("scroll", this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver((entries) =>
          this.onPaginationResize()
        );
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      let activeImages = Array.from(
        this.querySelectorAll(".product-single__media-image")
      );

      this.setEventListeners(this, activeImages);
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector(".product-single__media-zoom");
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute("title"),
        };
      });
      return images;
    }
    setEventListeners(container, activeImages) {
      let links = container.querySelectorAll(".product-single__media-zoom"),
        items = container.buildItems(activeImages),
        captionEl = container.dataset.captions,
        pswpElement = document.querySelectorAll(".pswp")[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true,
        };

      links.forEach((link) => {
        link.addEventListener("click", (event) => {
          let i = link.dataset.index;
          options.index = parseInt(i, 10);
          options.getThumbBoundsFn = () => {
            const thumbnail = link.closest(".product-single__media"),
              pageYScroll =
                window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width,
            };
          };
          if (typeof PhotoSwipe !== "undefined") {
            let pswp = new PhotoSwipe(
              pswpElement,
              PhotoSwipeUI_Default,
              items,
              options
            );
            pswp.listen("firstUpdate", function () {
              pswp.listen("parseVerticalMargin", function (item) {
                item.vGap = {
                  top: 50,
                  bottom: 50,
                };
              });
            });
            pswp.init();
          }
          event.preventDefault();
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector(
        ".slider-counter--current"
      );
      this.pageTotalElement = this.pagination.querySelector(
        ".slider-counter--total"
      );

      this.prevButton = this.pagination.querySelector(
        'button[name="previous"]'
      );
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      this.prevButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this)
      );
      this.nextButton.addEventListener(
        "click",
        this.onPaginationButtonClick.bind(this)
      );

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.scrollLeft + 1 * this.sliderItemOffset
          : this.scrollLeft - 1 * this.sliderItemOffset;
      this.scrollTo({
        left: this.slideScrollPosition,
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }

      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
      ) {
        this.nextButton.setAttribute("disabled", "disabled");
      } else {
        this.nextButton.removeAttribute("disabled");
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.scrollLeft
      );
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        let variantAvailabe = evt.submitter.closest('.add_to_cart_holder').querySelector('.productVariantPrice').getAttribute('data-variantprice')
        let variants = [];
        if(variantAvailabe){
          if(variantAvailabe.split('#').length > 0){
            variantAvailabe.split('#').forEach( each => variants.push(each.trim()))
          }else{
            variants.push(variantAvailabe)
          }
        }
        let presentVariantid = evt.submitter.closest('.product-form')?.querySelector('.custom-variant')?.value;
        if (!presentVariantid) {
            presentVariantid = evt.submitter.getAttribute('data-presentvarid');
        }
        let compareAtPrice = Number(evt.submitter.getAttribute('data-saleProduct'));
        evt.preventDefault();
        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        const submitbtnpdp = document.querySelector('#AddToCart.single-add-to-cart-button');      
        let curtainBanksDetails;
        if(submitbtnpdp.hasAttribute('curtain-banks-details')){
          curtainBanksDetails = submitbtnpdp.getAttribute("curtain-banks-details");
        }

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });
        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        let formData = new FormData(this.form);

        const addtocartbtnsticky = document.querySelector('#AddToCartSticky.single-add-to-cart-button');
        let curtainBanksDetailsSticky;
        if(addtocartbtnsticky){
          if (addtocartbtnsticky.hasAttribute('curtain-banks-details')) {
              curtainBanksDetailsSticky = addtocartbtnsticky.getAttribute("curtain-banks-details");
            if(curtainBanksDetailsSticky === 'yes'){
              formData.append("properties[Curtain Bangs]", curtainBanksDetailsSticky);
            }else if(curtainBanksDetailsSticky === 'no'){
              formData.append("properties[Curtain Bangs]", curtainBanksDetailsSticky);
            }
          }
        }
        if(curtainBanksDetails === 'yes'){
          formData.append("properties[Curtain Bangs]", curtainBanksDetails);
        }

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // Check if variant has compare_at_price and it's greater than price
        let variantHasCompareAtPrice = false;
        if (presentVariantid && (salePopupCheckBox == 'true' || salePopupCheckBox == true )) {
          const variantSelects = this.querySelector('variant-selects') || 
                                 this.closest('section')?.querySelector('variant-selects') ||
                                 document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);
          if (variantSelects) {
            try {
              const variantData = variantSelects.getVariantData();
              const currentVariant = variantData.find(v => v.id == presentVariantid);
              if (currentVariant && currentVariant.compare_at_price && currentVariant.price) {
                const compareAtPriceValue = parseFloat(currentVariant.compare_at_price);
                const variantPriceValue = parseFloat(currentVariant.price);
                variantHasCompareAtPrice = compareAtPriceValue > variantPriceValue;
              }
            } catch (e) {
              console.error('Error checking variant compare_at_price:', e);
            }
          }
        }

        if(variants.includes(presentVariantid) && (salePopupCheckBox == 'true' || salePopupCheckBox == true ) && variantHasCompareAtPrice){
        const modal = document.createElement('div');
            modal.innerHTML = `
                <div class="sale-popup-overlay">
                  <div class="sale-popup">
                      <p class='sale-popup-warning-text'>${salePopupText}</p>
                      <div class="sale-popup-buttons">
                          <button id="agreeBtn">${salePopupAtcBtn}</button>
                          <button id="cancelBtn">${salePopupCancelBtn}</button>
                      </div>
                  </div>
              </div>
            `;
            document.body.appendChild(modal);
            document.head.insertAdjacentHTML('beforeend', `
                <style>
                    .sale-popup-warning-text {
                      font-size: calc(var(--font-product-title-scale, 1)* .9375rem);
                      line-height: calc(var(--font-product-title-line-height-scale, 1)* 1.5);
                      font-weight: 500;
                      display: block;
                      text-transform: capitalize;
                      margin-bottom: 5px;
                    }
                    .sale-popup-overlay {
                        position: fixed;
                        top: 0; left: 0; width: 100%; height: 100%;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex; justify-content: center; align-items: center;
                        z-index: 1000;
                    }
                    .sale-popup {
                        background: #fff;
                        padding: 20px;
                        border-radius: 8px;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
                        text-align: center;
                        width: 320px;
                    }
                    .sale-popup-buttons {
                        margin-top: 15px;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                    }
                    .sale-popup-buttons button {
                        padding: 8px 12px;
                        border: none;
                        cursor: pointer;
                        border-radius: 5px;
                    }
                    #agreeBtn {
                        font-family: 'Tasa';
                        padding: 12px;
                        display: inline-flex;
                        padding: 7px 30px;
                        align-items: center;
                        cursor: pointer;
                        border-radius: var(--button-border-radius, 0px);
                        text-align: center;
                        color: #fff;
                        background-color: var(--outline-button-label, var(--color-accent));
                    }
                    #cancelBtn {
                        ont-family: 'Tasa';
                        padding: 12px;
                        display: inline-flex;
                        padding: 7px 30px;
                        align-items: center;
                        cursor: pointer;
                        border-radius: var(--button-border-radius, 0px);
                        text-align: center;
                        color: #fff;
                        background-color: gray;
                    }
                </style>
            `);
            document.getElementById("agreeBtn").addEventListener("click", () => {
              fetch(`${theme.routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  dispatchCustomEvent("product:variant-error", {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);
                  return;
                }

                this.renderContents(response);

                dispatchCustomEvent("cart:item-added", {
                  product: response.hasOwnProperty("items")
                    ? response.items[0]
                    : response,
                });
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                submitButtons.forEach((submitButton) => {
                  submitButton.classList.remove("loading");
                  submitButton.removeAttribute("aria-disabled");
                });
              });

                modal.remove();
            });

            document.getElementById("cancelBtn").addEventListener("click", () => {
                modal.remove();
                submitButtons.forEach((submitButton) => {
                  if (submitButton.classList.contains("loading")) {;
                  submitButton.removeAttribute("aria-disabled");
                  submitButton.classList.remove("loading");
                  }
                });
                return;
            });
        }
        else{
          fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
        }
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (typeof CartDrawer !== "undefined") {
            renderContents();
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById("Product-Drawer");
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer
            .querySelector(".product-quick-images--container")
            .classList.remove("active");
          document.body.classList.remove("open-quick-view");

          if (window.innerWidth < 1069) {
            product_drawer.classList.remove("active");
            if (document.getElementById("Cart-Drawer")) {
              document.getElementById("Cart-Drawer").classList.add("active");
              document.body.classList.add("open-cart");
              document
                .getElementById("Cart-Drawer")
                .querySelector(".product-recommendations--full")
                .classList.add("active");
              dispatchCustomEvent("cart-drawer:open");
            }
          } else {
            product_drawer
              .querySelector(".product-quick-images--container")
              .addEventListener("transitionend", function () {
                product_drawer.classList.remove("active");

                if (document.getElementById("Cart-Drawer")) {
                  document
                    .getElementById("Cart-Drawer")
                    .classList.add("active");
                  document.body.classList.add("open-cart");
                  document
                    .getElementById("Cart-Drawer")
                    .querySelector(".product-recommendations--full")
                    .classList.add("active");
                  dispatchCustomEvent("cart-drawer:open");
                }
              });
          }

          if (!document.getElementById("Cart-Drawer")) {
            document.body.classList.remove("open-cc");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          document.body.classList.add("open-cc");
          document.body.classList.add("open-cart");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector(".product-add-to-cart-sticky--inner"),
        content = this.querySelector(".product-add-to-cart-sticky--content");

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add("sticky-open");
          let radiobtn =  document.querySelector('.curtains-banks-pop-containerSticky label #no');
          if(radiobtn){
            radiobtn.checked = 'true';
          }
          },
          onReverseComplete: () => {
            button.classList.remove("sticky-open");
          },
        });

        tl.set(
          content,
          {
            display: "block",
            height: "auto",
          },
          "start"
        ).from(
          content,
          {
            height: 0,
            duration: 0.25,
          },
          "start+=0.001"
        );

        button.addEventListener("click", function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener("click", function () {
          content.classList.toggle("active");
          return false;
        });
      }
    }
    setupObservers() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const atc = document.getElementById("AddToCart") || form;
      const footer = document.getElementById("footer");

      this.formPassed = false;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.isIntersecting) {
                this.classList.remove("sticky--visible");
              } else if (this.formPassed) {
                this.classList.add("sticky--visible");
              }
              return;
            }

            if (entry.target === atc) {
              if (entry.isIntersecting) {
                this.formPassed = false;
                this.classList.remove("sticky--visible");
              } else if (entry.boundingClientRect.bottom < 0) {
                this.formPassed = true;
                this.classList.add("sticky--visible");
              }
            }
          });
        },
        {
          threshold: 0,
        }
      );

      if (atc) observer.observe(atc);
      if (footer) observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
